// extracted by mini-css-extract-plugin
module.exports = {"red":"person_red_2f3Lq"};